var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fail"},[_c('h1',[_vm._v("При оплате возникла ошибка. Попробуйте "),_c('router-link',{attrs:{"to":{ path: 'hall'}}},[_vm._v("еще раз")]),_vm._v(".")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }